// src/pages/Dashboard.jsx
import { Outlet } from 'react-router-dom';
import Sidebar from '../MainLayout/Sidebar';
import Header from '../MainLayout/Header';
import PromotionsList from './PromoList';

export default function Dashboard() {
  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header />
        <main className="flex-1 overflow-auto p-6 bg-gradient-to-r from-sky-100 to-white">

          <PromotionsList />

        </main>
      </div>
    </div>
  );
}